module.exports = __webpack_public_path__ + "static/006-f72a3980918a3064876b324e441653f0.jpg";